import _find from 'lodash/find';

export default class EditEmployeeController {
  /** @ngInject */
  constructor(
    $log, $mdDialog, $mdToast,
    roles,
    employee,
    schoolCommonRoom,
    EmployeeService
  ) {
    this.$log = $log;
    this.$mdDialog = $mdDialog;
    this.$mdToast = $mdToast;
    this.roles = roles;
    this.employee = employee;
    this.schoolCommonRoom = schoolCommonRoom;
    this.EmployeeService = EmployeeService;
    this.role = _find(this.roles, role => role.id === this.employee.role);
  }

  update(form, id = 0) {
    if (form.$invalid) {
      return false;
    }

    if (this.schoolCommonRoom) {
      id = this.schoolCommonRoom.id;
    }

    this.employee.role = this.role.id;
    this.employee.roleName = this.role.name;
    this.EmployeeService.editEmployee(this.employee, id)
      .then(employee => {
        this.$mdDialog.hide(employee);
        this.$mdToast.show(
          this.$mdToast.simple()
            .textContent('Pomyślnie edytowano pracownika')
            .position('bottom right')
            .hideDelay(3000)
        );
      })
      .catch(error => {
        this.$mdDialog.show(
          this.$mdDialog.extendError({
            locals: {error}
          })
        );
      });
  }

  cancel() {
    this.$mdDialog.cancel();
  }
}
